import type { LucideIcon } from "lucide-react";
import { olcu } from "@halkora/tokens";

const STROKE = Number(olcu["size.iconStroke"]);
const SIZES = {
  sm: parseFloat(olcu["size.icon.sm"]),
  md: parseFloat(olcu["size.icon.md"]),
  lg: parseFloat(olcu["size.icon.lg"]),
} as const;

export type IconSize = keyof typeof SIZES;

/** Lucide ikonu; boyut/kalınlık token'dan (§8). Süs ikonu `aria-hidden`. */
export function Icon({ icon: I, size = "md", className }: { icon: LucideIcon; size?: IconSize; className?: string }) {
  return <I size={SIZES[size]} strokeWidth={STROKE} absoluteStrokeWidth aria-hidden="true" className={className} />;
}
